export const formatDate= (date) =>{

  const yyyy = date.getFullYear();
  let mm = date.getMonth();
  let dd = date.getDate();

  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;

  let newDate = new Date(Date.UTC(yyyy, mm, dd));
  return newDate;
}